<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="register-welcome">欢迎加入文雅慕课</div>
    <custom-input type="mobile" rules="mobile" @validate="handleValid" v-model="mobile"></custom-input>
    <custom-input type="code" rules="code" @validate="handleValid" :mobile="mobile" v-model="code" codeType="regist"></custom-input>
    <custom-input type="password" rules="password" placeholder="请输入6-16位（数字、字母、_）密码" @validate="handleValid" v-model="password"></custom-input>
    <custom-input type="password" rules="password" placeholder="请确认密码" @validate="handleValid" v-model="passwordConfirm"></custom-input>
    <div class="register-confirm"><div class="register-check"></div>我已阅读并同意<span  @click="$router.push('/portal/login/protocol')">《服务条约》</span></div>
    <div class="register-login">已有账号？<span @click="$router.push('/login')">去登陆</span></div>
    <div class="account-button" @click="register">注册</div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
  </div>
</template>

<script>
  import "@/asset/css/account.css";
  import {dtCheck} from "../../util/dt-checkbox";
  export default {
    name: "register",
    data(){
      return{
        error:[],
        isDialogShow:false,
        mobile:"",
        password:"",
        passwordConfirm:"",
        code:"",
        agree:false
      }
    },
    methods:{
      register(){
        //遍历所有子组件，验证其中的custom-input组件
        this.error=[];
        this.$children.forEach((value,index)=>{
          if(value.$options.name=="custom-input"){
            value.validate();
          }
        })
        if(this.error.length>0){
          this.isDialogShow=true;
        }
        else{
          this.$api.get("",{
            api:"/v1/passport/register",
            mobile:this.mobile,
            password:this.password,
            confirm_psd:this.passwordConfirm,
            verify_code:this.code,
            agreement:this.agree?1:0,
            center_id:this.tools.getCookie("center_id") || ""
          },res=>{
            if(res.status===1){
              this.$toast("注册成功");
              window.setTimeout(()=>{
                this.$router.push("/login");
              },1000);
            }
          })
        }
      },
      handleValid(obj){
        if(!obj.result){
          this.error.push(obj.msg);
        }
      }
    },
    mounted(){
      //自定义复选框
      this.agree=dtCheck({
        el:document.querySelector(".register-check"),
        className:"register-check-checked"
      });
    }
  }
</script>

<style scoped>
  .register-welcome{
    margin-top:0.24rem;
    font-size:0.507rem;
    line-height:0.507rem;
    color:#333;
    text-align: center;
    font-weight:bold;
  }
  .register-check{
    display: inline-block;
    width:0.293rem;
    height:0.293rem;
    margin-right:0.147rem;
    border:1px solid #999;
    border-radius: 2px;
  }
  .register-check-checked{
    background:url("../../asset/img/account/selected.png") center center no-repeat;
    background-size:0.253rem;
  }
  .register-confirm{
    margin:0.533rem 0.4rem 0 0.4rem;
    color:#0c539b;
    font-size:0.373rem;
  }
  .register-login{
    margin-top:3.6rem;
    text-align: center;
    color:#999;
  }
  .register-login span{
    color:#0c539b;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue